<template>
	<div class="o-container o-container--thin registration-page">
		<registration-form
			:submit="register"
			:errorMessage="message"
		/>
	</div>
</template>

<script>
	import RegistrationForm from '../forms/RegistrationForm.vue';
    import '../../store/modules/session/session';

	export default {
		components: {
			RegistrationForm
		},
		props: {
			message: {
				type: Object,
				validator(messageObject) {
					const result = !!messageObject.value;
					if (!result) {
						// console.warn('"message" object must have "value" parameter');
					}
					return result;
				}
			}
		},
		methods: {
			register(credentials) {
			    if(credentials.email){
			        this.$session.set('register_email', credentials.email);
				}

				if(credentials.code){
			        this.$session.set('register_code', credentials.code);
				}

				console.info("START_calling_user.REGISTER");
				console.time("TIME_calling_user.REGISTER");
				return this.$store.dispatch('user/REGISTER', credentials).then((userData) => {
                    console.timeEnd("TIME_calling_user.REGISTER");

					// redirect to the verification page
					this.$router.push({
						name: 'verify'
					});
				});
			}
		}
	}
</script>
